import React, { useRef } from 'react'
import { Chip, Tooltip } from '@material-ui/core'

import CustomTextField from 'components/CustomTextField'

export const PUSH_NAME_TOKEN = '[name]'

const NAME_TOKEN_TOOLTIP =
  'Se reemplaza por el primer nombre del usuario al enviar. Si no hay nombre, se omite de forma limpia.'

type PushNameTokenFieldProps = React.ComponentProps<typeof CustomTextField>

const PushNameTokenField: React.FC<PushNameTokenFieldProps> = ({
  value,
  onChange,
  maxLength,
  disabled,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement | HTMLTextAreaElement>(null)

  const insertToken = () => {
    if (disabled || !onChange) return

    const current = value == null ? '' : String(value)
    const input = inputRef.current
    const start = input?.selectionStart ?? current.length
    const end = input?.selectionEnd ?? start
    const next = `${current.slice(0, start)}${PUSH_NAME_TOKEN}${current.slice(end)}`

    if (maxLength != null && next.length > maxLength) return

    onChange({
      target: { value: next },
    } as React.ChangeEvent<HTMLInputElement>)

    requestAnimationFrame(() => {
      const caret = start + PUSH_NAME_TOKEN.length
      input?.focus()
      input?.setSelectionRange(caret, caret)
    })
  }

  return (
    <>
      <CustomTextField
        {...rest}
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        disabled={disabled}
        inputRef={inputRef}
      />
      <Tooltip title={NAME_TOKEN_TOOLTIP} placement="top-start">
        <span>
          <Chip
            size="small"
            label={PUSH_NAME_TOKEN}
            onClick={insertToken}
            clickable={!disabled}
            disabled={Boolean(disabled)}
            style={{ marginTop: 8, fontFamily: 'Montserrat', fontSize: 12 }}
          />
        </span>
      </Tooltip>
    </>
  )
}

export default PushNameTokenField
